export const PHONE_UPPER_BOUNDARY = 600;
export const TABLET_PORTRAIT_UPPER_BOUNDARY = 1024;
export const TABLET_LANDSCAPE_UPPER_BOUNDARY = 1200;
export const DESKTOP_UPPER_BOUNDARY = 1400;
export const DESKTOP_BIG_UPPER_BOUNDARY = 1800;
